import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { COMMISSION_RATE_VALIDATORS } from '@shared/forms/forms.constants';
import { SharedStore } from '@shared/store/shared.signal-store';
import { isDefined } from '@stillmandigital/common';
import {
  toApiReferralAgentRateValue,
  toViewReferralAgentRateValue,
} from 'app/settings/store/referral-agents/referral-agents.utils';

@Component({
  selector: 'app-update-referral-agent',
  templateUrl: './update-referral-agent.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatLabel,
    MatFormField,
    ReactiveFormsModule,
    MatInput,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class UpdateReferralAgentComponent implements OnInit {
  private readonly _sharedStore = inject(SharedStore);
  private readonly _fb = inject(NonNullableFormBuilder);
  private readonly _destroyRef = inject(DestroyRef);

  public readonly updateForm = this._fb.group({
    name: ['', Validators.required],
    commissionRate: [0, COMMISSION_RATE_VALIDATORS],
  });

  private readonly _selectedReferralAgent$ = toObservable(this._sharedStore.selectedReferralAgent);

  public ngOnInit() {
    this._selectedReferralAgent$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(referralAgent => {
      const formValue = {
        name: referralAgent?.name,
        commissionRate: toViewReferralAgentRateValue(referralAgent?.commissionRate),
      };

      this.updateForm.reset(formValue);
    });
  }

  public update() {
    const { name, commissionRate } = this.updateForm.value;
    const rate = toApiReferralAgentRateValue(commissionRate);
    const referralAgentId = this._sharedStore.selectedReferralAgent()?.id;

    if (isDefined(name) && isDefined(rate) && isDefined(referralAgentId)) {
      this._sharedStore.updateReferralAgent({
        name,
        commissionRate: rate,
        referralAgentId,
      });
    }
  }
}
